export const cleanCurrentUrlQuery = (): void => {
  const cleanUrl = `${window.location.origin}${window.location.pathname}`
  if (window.history && typeof window.history.replaceState === 'function') {
    window.history.replaceState({}, document.title, cleanUrl)
  }
}
